import { always, pathOr, remove } from 'ramda'
import { createReducer } from '../../utilities/miscellaneous'

// initial state
export const INITIAL_STATE = {
  currentShow: {},
  error: false,
  isLoading: false,
  schedules: [],
  upcomingShows: [],
}

// action types
export const CLEAN = 'liveUpdatingShowList/CLEAN'
export const INITIALIZE = 'liveUpdatingShowList/INIT_PLAYER'
export const SCHEDULES_RECEIVED = 'liveUpdatingShowList/SCHEDULES_RECEIVED'
export const UPDATE_UPCOMING_SHOWS = 'liveUpdatingShowList/UPDATE_UPCOMING_SHOWS'
export const ERROR = 'liveUpdatingShowList/ERROR'

// initialize :: () -> Action
export const initialize = always({ type: INITIALIZE })

// clean :: () -> Action
export const clean = always({ type: CLEAN })

// schedulesReceived :: [Schedule] -> Action
export const schedulesReceived = schedules => ({
  type: SCHEDULES_RECEIVED,
  schedules,
})

// updateUpcomingShows :: [Schedule] -> Action
export const updateUpcomingShows = shows => ({
  type: UPDATE_UPCOMING_SHOWS,
  shows: shows || [],
})

// error :: () -> Action
export const error = always({ type: ERROR })

// liveUpdatingShowList :: (State, Action *) -> State
export default createReducer(INITIAL_STATE, {
  [CLEAN]: always(INITIAL_STATE),

  [INITIALIZE]: state => ({
    ...state,
    isLoading: true,
  }),

  [SCHEDULES_RECEIVED]: (state, { schedules }) => ({
    ...state,
    isLoading: false,
    schedules: schedules || [],
  }),

  [UPDATE_UPCOMING_SHOWS]: (state, { shows }) => ({
    ...state,
    currentShow: pathOr({}, [0, 'show'], shows),
    upcomingShows: remove(0, 1, shows),
  }),

  [ERROR]: state => ({
    ...state,
    isLoading: false,
    error: true,
  }),
})
